import React from "react";
import { useContext } from "react";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import TildeOkCircle from "../../../assets/images/generico/TildeOkCircle";
import { PortalContext } from "../../../context/Provider";
import "./PerfilDatosPersonalesStyle.css";

const ProfileColumn2 = () => {
  const { modalDispatch, textosState } = useContext(PortalContext);

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const showModalBeneficios = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Beneficios del Portal Web",
        texto: (
          <div style={{ marginLeft: 65, marginBottom: 75 }}>
            {textosState.textos.data === null
              ? ""
              : Array.from(textosState.textos.data.beneficios).map(
                  (item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <TildeOkCircle
                          texto={item.descripcion}
                          colorTilde="var(--color-black)"
                          colorTexto="c-black"
                        />
                      </React.Fragment>
                    );
                  }
                )}
          </div>
        ),
        dissmiss: dissmiss,
      },
      [
        {
          text: "Agregar luego",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: dissmiss,
        },
        {
          text: "Agregar un familiar",
          clase: "btn-Mensaje-1 rb16m bgc-primary c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };
  return (
    <React.Fragment>
      <h2 className="ptur-datos-personales-titulo rb18b">
        Agregar un miembro familiar
      </h2>
      <h4 className="ptur-datos-personales-texto-familiar rb16t">
        Tu grupo familiar puede disfrutar de todos los beneficios del Portal
        Online. como sacar turnos, hacer consultas y visualizar imágenes e
        informes del familiar.
      </h4>
      <h4 className="ptur-datos-personales-texto-familiar2 rb16t">
        Vos también podés sacar turnos por ellos.
      </h4>
      <button className="ptur-datos-personales-boton rb18m">
        Agregar un familiar
      </button>
      {textosState.textos.data.beneficios?.length <= 0 ? (
        ""
      ) : (
        <div className="ptur-datos-personales-beneficios">
          <button
            onClick={showModalBeneficios}
            className="ptur-datos-personales-beneficiosBtn underline rb16m"
          >
            Ver todos los beneficios
          </button>
        </div>
      )}
    </React.Fragment>
  );
};

export default ProfileColumn2;
